import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import React from "react";

const ActionButton = ({ ...props }) => {
  return (
    <Button loading={props.loading} block icon={<FontAwesomeIcon icon={["fas", props.icon]} />} className="action-button" onClick={props.onClick}>
      {props.children}
    </Button>
  );
};

export default ActionButton;
